// import * as firebase from 'firebase';
// import 'firebase/auth'
import Vue from 'vue';
import Router from 'vue-router';

// Containers
const ContainerPsicologo = () => import('@/containers/ContainerPsicologo');
const ContainerPaciente = () => import('@/containers/ContainerPaciente');

// Views
const CadastroPaciente = resolve => require(['@/views/paciente/Cadastro.vue'], resolve);
const CadastroPsicologo = resolve => require(['@/views/psicologo/Cadastro.vue'], resolve);

const LoginPsicologo = resolve => require(['@/views/psicologo/Login.vue'], resolve);
const LoginPaciente = resolve => require(['@/views/paciente/Login.vue'], resolve);

const ProfilePaciente = resolve => require(['@/views/paciente/Profile.vue'], resolve);
const ProfilePsicologo = resolve => require(['@/views/psicologo/Profile.vue'], resolve);

const EditProfilePaciente = resolve => require(['@/views/paciente/EditProfile.vue'], resolve);
const EditProfilePsicologo = resolve => require(['@/views/psicologo/EditProfile.vue'], resolve);

const BuscaPaciente = resolve => require(['@/views/paciente/BuscaPaciente.vue'], resolve);
const HistoricoPacientes = resolve => require(['@/views/psicologo/HistoricoPacientes.vue'], resolve);

const DetalheConsulta = resolve => require(['@/views/psicologo/DetalheConsulta.vue'], resolve);
const DetalheConsultaPaciente = resolve => require(['@/views/paciente/DetalheConsulta.vue'], resolve);

const FinanceiroPaciente = resolve => require(['@/views/paciente/Financeiro.vue'], resolve);
const FinanceiroPsicologo = resolve => require(['@/views/psicologo/Financeiro.vue'], resolve);

const ConfigPage = resolve => require(['@/views/Config.vue'], resolve);

const DashboardPaciente = () => import('@/views/paciente/Dashboard');
const DashboardPsicologo = () => import('@/views/psicologo/Dashboard');

// Public
const Landing = () => import('@/views/publico/Home');
const AboutPage = resolve => require(['@/views/publico/About'], resolve);
const Privacidade = resolve => require(['@/views/publico/Privacidade'], resolve);
const Termo = resolve => require(['@/views/publico/Termo'], resolve);

const changePassword = () => import('@/views/changePassword');
const Help = () => import('@/views/Help');
const Others = () => import('@/views/Others');

// Schedule Psicologo
const CreateSchedule = resolve => require(['@/views/psicologo/CreateSchedule'], resolve);
const EditSchedule = resolve => require(['@/views/psicologo/EditSchedule'], resolve);
const Schedule = resolve => require(['@/views/psicologo/Schedule'], resolve);

// Schedule Paciente
const SchedulePaciente = resolve => require(['@/views/paciente/Schedule'], resolve);
const Scheduling = resolve => require(['@/views/paciente/Scheduling'], resolve);

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/psicologo',
      component: {
        render(c) { return c('router-view'); },
      },
      children: [
        {
          path: '/',
          name: 'psicologo',
          redirect: '/psicologo/dashboard',
          component: ContainerPsicologo,
          children: [
            {
              path: 'dashboard',
              name: 'DashboardPsicologo',
              component: DashboardPsicologo,
              meta: {
                requiresAuth: true,
                psyAuth: true,
                patientAuth: false,
              },
            },
            {
              path: 'profile',
              name: 'ProfilePsicologo',
              component: ProfilePsicologo,
              meta: {
                requiresAuth: true,
                psyAuth: true,
                patientAuth: false,
              },
            },
            {
              path: 'financeiro',
              name: 'FinanceiroPsicologo',
              component: FinanceiroPsicologo,
              meta: {
                requiresAuth: true,
                psyAuth: true,
                patientAuth: false,
              },
            },
            {
              path: 'edit-profile',
              name: 'EditProfilePsicologo',
              component: EditProfilePsicologo,
              meta: {
                requiresAuth: true,
                psyAuth: true,
                patientAuth: false,
              },
            },
            {
              path: 'schedule',
              name: 'Schedule',
              component: Schedule,
              meta: {
                requiresAuth: true,
                psyAuth: true,
                patientAuth: false,
              },
            },
            {
              path: 'create-schedule',
              name: 'CreateSchedule',
              component: CreateSchedule,
              meta: {
                requiresAuth: true,
                psyAuth: true,
                patientAuth: false,
              },
            },
            {
              path: 'historico-pacientes',
              name: 'HistoricoPacientes',
              component: HistoricoPacientes,
              meta: {
                requiresAuth: true,
                psyAuth: true,
                patientAuth: false,
              },
            },
            {
              path: 'detalhe-consulta/:id',
              name: 'DetalheConsulta',
              component: DetalheConsulta,
              meta: {
                requiresAuth: true,
                psyAuth: true,
                patientAuth: false,
              },
            },
            {
              path: 'edit-schedule',
              name: 'EditSchedule',
              component: EditSchedule,
              meta: {
                requiresAuth: true,
                psyAuth: true,
                patientAuth: false,
              },
            },
            {
              path: 'help',
              component: Help,
              name: 'Help',
              meta: {
                requiresAuth: true,
              },
            },
            {
              path: 'config',
              name: 'ConfigPage',
              component: ConfigPage,
              meta: {
                requiresAuth: true,
              },
            },
            {
              path: 'others/:id',
              component: Others,
              name: 'Others',
              meta: {
                requiresAuth: true,
              },
            },
          ],
        },
        {
          path: 'login',
          name: 'LoginPsicologo',
          component: LoginPsicologo,
        },
        {
          path: 'cadastro',
          name: 'CadastroPsicologo',
          component: CadastroPsicologo,
        },
        {
          path: '/',
          redirect: 'profile/:id',
          name: 'PsicologoProfile',
          component: ContainerPaciente,
          children: [
            {
              path: 'profile/:id',
              component: ProfilePsicologo,
              meta: {
                requiresAuth: true,
              },
            },
            {
              path: 'scheduling/:id',
              name: 'Scheduling',
              component: Scheduling,
              meta: {
                requiresAuth: true,
              },
            },
          ],
        },
      ],
    },
    {
      path: '/paciente',
      component: {
        render(c) { return c('router-view'); },
      },
      children: [
        {
          path: '/',
          name: 'paciente',
          redirect: '/paciente/dashboard',
          component: ContainerPaciente,
          children: [
            {
              path: 'dashboard',
              name: 'DashboardPaciente',
              component: DashboardPaciente,
              meta: {
                requiresAuth: true,
                psyAuth: false,
                patientAuth: true,
              },
            },
            {
              path: 'profile',
              name: 'ProfilePaciente',
              component: ProfilePaciente,
              meta: {
                requiresAuth: true,
                psyAuth: false,
                patientAuth: true,
              },
            },
            {
              path: 'financeiro',
              name: 'FinanceiroPaciente',
              component: FinanceiroPaciente,
              meta: {
                requiresAuth: true,
                psyAuth: false,
                patientAuth: true,
              },
            },
            {
              path: 'busca',
              name: 'BuscaPaciente',
              component: BuscaPaciente,
              meta: {
                requiresAuth: true,
                psyAuth: false,
                patientAuth: true,
              },
            },
            {
              path: 'detalhe-consulta/:id',
              name: 'DetalheConsultaPaciente',
              component: DetalheConsultaPaciente,
              meta: {
                requiresAuth: true,
                psyAuth: false,
                patientAuth: true,
              },
            },
            {
              path: 'edit-profile',
              name: 'EditProfilePaciente',
              component: EditProfilePaciente,
              meta: {
                requiresAuth: true,
                psyAuth: false,
                patientAuth: true,
              },
            },
            {
              path: 'schedule',
              name: 'SchedulePaciente',
              component: SchedulePaciente,
              meta: {
                requiresAuth: true,
                psyAuth: false,
                patientAuth: true,
              },
            },
            {
              path: 'help',
              component: Help,
              name: 'Help',
              meta: {
                requiresAuth: true,
              },
            },
            {
              path: 'config',
              name: 'ConfigPage',
              component: ConfigPage,
              meta: {
                requiresAuth: true,
              },
            },
            {
              path: 'others/:id',
              component: Others,
              name: 'Others',
              meta: {
                requiresAuth: true,
              },
            },
          ],
        },
        {
          path: 'login',
          name: 'LoginPaciente',
          component: LoginPaciente,
        },
        {
          path: 'cadastro',
          name: 'CadastroPaciente',
          component: CadastroPaciente,
        },
        {
          path: '/',
          redirect: 'profile/:id',
          name: 'PacienteProfile',
          component: ContainerPsicologo,
          children: [
            {
              path: 'profile/:id',
              component: ProfilePaciente,
              meta: {
                requiresAuth: true,
              },
            },
          ],
        },
      ],
    },
    {
      path: '/',
      component: {
        render(c) { return c('router-view'); },
      },
      children: [
        {
          path: '/',
          name: '/',
          redirect: '',
          component: Landing,
        },
        {
          path: 'sobre',
          name: 'sobre',
          component: AboutPage,
        },
        {
          path: 'privacidade',
          name: 'privacidade',
          component: Privacidade,
        },
        {
          path: 'termo',
          name: 'termo',
          component: Termo,
        },
        {
          path: 'change-password',
          component: changePassword,
          name: 'changePassword',
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
  ],
});

// router.beforeEach((to, from, next) => {
//   const currentUser = firebase.auth().currentUser;
//   const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

//   // dar post/get com o uid do firebase, na api de LC
//   // pegar o objeto com o tipo do perfil dele (id, category e token)
//   // fazer condicionais:
//   // SE FOR PSICOLOGO, ir para home do psicologo, se for paciente, para a home do paciente.

//   if (requiresAuth && !currentUser) next('login');
//   else if (!requiresAuth && currentUser) {
//     next('$route.fullPath');
//   }
//   else next();
// });

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('user-token');
  const category = localStorage.getItem('user-category');
  const publicPages = ['/login'];
  const auxPath = !publicPages.includes(to.path);

  if (to.meta.requiresAuth) {
    if (!token) {
      if (to.path.includes('/psicologo')) {
        next({ name: 'LoginPsicologo' });
      } else if (to.path.includes('/paciente')) {
        next({ name: 'LoginPaciente' });
      }
    } else if (to.meta.psyAuth) {
      if (category == 'psychologist') {
        next();
      } else {
        next({ name: 'LoginPsicologo' });
      }
    } else if (to.meta.patientAuth) {
      if (category == 'patient') {
        next();
      } else {
        next({ name: 'LoginPaciente' });
      }
    } else {
      next();
    }
  } else if (auxPath && token) {
    if (to.path.includes('/psicologo') && category == 'psychologist') {
      next({ name: 'psicologo' });
    } else if (to.path.includes('/paciente') && category == 'patient') {
      next({ name: 'paciente' });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
